/* Saatchi Watch — FAQ search and filtering, contact form helpers. */
(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const say = m => { let r = $('#spLive'); if (!r) { r = document.createElement('div'); r.id = 'spLive'; r.className = 'sr'; r.setAttribute('aria-live', 'polite'); r.setAttribute('role', 'status'); document.body.appendChild(r); } r.textContent = ''; setTimeout(() => { r.textContent = m; }, 60); };

function faq(sec) {
  if (sec._sw) return; sec._sw = 1;
  const items = $$('.fq', sec), input = $('[data-fq-search]', sec), tabs = $$('[data-fq-tab]', sec), none = $('[data-fq-none]', sec);
  let cat = 'all', q = '';
  const apply = () => {
    let n = 0;
    items.forEach(it => {
      const okCat = cat === 'all' || it.dataset.cat === cat;
      const text = (it.textContent || '').toLowerCase();
      const okQ = !q || text.includes(q);
      const show = okCat && okQ;
      it.hidden = !show;
      if (show) { n++; if (q) it.open = true; }
    });
    if (none) none.hidden = n > 0;
    say(n === 0 ? 'No questions match your search.' : `${n} question${n === 1 ? '' : 's'} shown.`);
  };
  let t;
  input?.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => { q = input.value.trim().toLowerCase(); apply(); }, 180); });
  tabs.forEach(b => b.addEventListener('click', () => {
    cat = b.dataset.fqTab;
    tabs.forEach(x => x.setAttribute('aria-pressed', x === b));
    apply();
  }));
  // open the question named in the URL hash
  if (location.hash.length > 1) {
    const target = sec.querySelector(location.hash);
    if (target && target.classList.contains('fq')) { target.open = true; setTimeout(() => target.scrollIntoView({ block: 'center', behavior: 'smooth' }), 120); }
  }
}

function contact(sec) {
  if (sec._sw) return; sec._sw = 1;
  const box = $('[data-msg]', sec), counter = $('[data-msg-count]', sec);
  if (box && counter) {
    const max = +box.getAttribute('maxlength') || 0;
    const upd = () => { counter.textContent = max ? `${box.value.length} / ${max}` : box.value.length; };
    box.addEventListener('input', upd); upd();
  }
  const ok = $('.ct-ok', sec);
  if (ok) setTimeout(() => ok.scrollIntoView({ block: 'center', behavior: 'smooth' }), 200);
  // opening hours indicator, calculated in the shopper's browser from the store's stated hours
  const live = $('[data-hours]', sec);
  if (live) {
    const tz = live.dataset.tz || 'America/New_York';
    const open = +live.dataset.open, close = +live.dataset.close;
    try {
      const now = new Date();
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', hour12: false, weekday: 'short' }).formatToParts(now);
      const hour = +parts.find(p => p.type === 'hour').value;
      const day = parts.find(p => p.type === 'weekday').value;
      const weekday = !['Sat', 'Sun'].includes(day);
      const isOpen = weekday && hour >= open && hour < close;
      live.classList.toggle('off', !isOpen);
      $('span', live).textContent = isOpen ? live.dataset.openText : live.dataset.closedText;
      live.hidden = false;
    } catch (e) {}
  }
}

function init(r = document) { $$('[data-faq]', r).forEach(faq); $$('[data-contact]', r).forEach(contact); }
document.addEventListener('shopify:section:load', e => init(e.target));
document.readyState === 'loading' ? addEventListener('DOMContentLoaded', () => init()) : init();
})();